//# sourceMappingURL=cell_mapping.mjs.map
/// <reference types="./cell_mapping.d.mts" />
import * as $json from "../../gleam_json/gleam/json.mjs";
import * as $dict from "../../gleam_stdlib/gleam/dict.mjs";
import * as $decode from "../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $list from "../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../gleam_stdlib/gleam/option.mjs";
import * as $result from "../../gleam_stdlib/gleam/result.mjs";
import * as $cell_mapping from "../data/proposal_element/cell_mapping.mjs";
import * as $decrypt from "../decrypt.mjs";
import { toList, CustomType as $CustomType } from "../gleam.mjs";

export class CellNode extends $CustomType {
  constructor(coordinates, cell_type, outgoing) {
    super();
    this.coordinates = coordinates;
    this.cell_type = cell_type;
    this.outgoing = outgoing;
  }
}
export const CellNode$CellNode = (coordinates, cell_type, outgoing) =>
  new CellNode(coordinates, cell_type, outgoing);
export const CellNode$isCellNode = (value) => value instanceof CellNode;
export const CellNode$CellNode$coordinates = (value) => value.coordinates;
export const CellNode$CellNode$0 = (value) => value.coordinates;
export const CellNode$CellNode$cell_type = (value) => value.cell_type;
export const CellNode$CellNode$1 = (value) => value.cell_type;
export const CellNode$CellNode$outgoing = (value) => value.outgoing;
export const CellNode$CellNode$2 = (value) => value.outgoing;

export class SheetCellGraph extends $CustomType {
  constructor(schema_version, sheet_name, nodes) {
    super();
    this.schema_version = schema_version;
    this.sheet_name = sheet_name;
    this.nodes = nodes;
  }
}
export const SheetCellGraph$SheetCellGraph = (schema_version, sheet_name, nodes) =>
  new SheetCellGraph(schema_version, sheet_name, nodes);
export const SheetCellGraph$isSheetCellGraph = (value) =>
  value instanceof SheetCellGraph;
export const SheetCellGraph$SheetCellGraph$schema_version = (value) =>
  value.schema_version;
export const SheetCellGraph$SheetCellGraph$0 = (value) => value.schema_version;
export const SheetCellGraph$SheetCellGraph$sheet_name = (value) =>
  value.sheet_name;
export const SheetCellGraph$SheetCellGraph$1 = (value) => value.sheet_name;
export const SheetCellGraph$SheetCellGraph$nodes = (value) => value.nodes;
export const SheetCellGraph$SheetCellGraph$2 = (value) => value.nodes;

function node_decoder() {
  return $decode.field(
    "coordinates",
    $cell_mapping.coordinates_decoder(),
    (coordinates) => {
      return $decode.field(
        "cell_type",
        $decode.string,
        (cell_type) => {
          return $decrypt.optional_field(
            "outgoing",
            $decode.list($cell_mapping.edge_decoder()),
            (outgoing) => {
              let outgoing$1 = $option.unwrap(outgoing, toList([]));
              return $decode.success(
                new CellNode(coordinates, cell_type, outgoing$1),
              );
            },
          );
        },
      );
    },
  );
}

export function decoder() {
  return $decode.field(
    "schema_version",
    $decode.int,
    (schema_version) => {
      return $decode.field(
        "sheet_name",
        $decode.string,
        (sheet_name) => {
          return $decode.field(
            "nodes",
            $decode.list(node_decoder()),
            (nodes) => {
              return $decode.success(
                new SheetCellGraph(schema_version, sheet_name, nodes),
              );
            },
          );
        },
      );
    },
  );
}

function encode_node(node) {
  let $ = node.coordinates;
  let x = $[0];
  let y = $[1];
  return $json.object(
    toList([
      [
        "coordinates",
        $json.object(toList([["x", $json.int(x)], ["y", $json.int(y)]])),
      ],
      ["cell_type", $json.string(node.cell_type)],
      ["outgoing", $json.array(node.outgoing, $cell_mapping.encode_edge)],
    ]),
  );
}

export function encode(graph) {
  return $json.object(
    toList([
      ["schema_version", $json.int(graph.schema_version)],
      ["sheet_name", $json.string(graph.sheet_name)],
      ["nodes", $json.array(graph.nodes, encode_node)],
    ]),
  );
}

/**
 * Rebuilds a detection graph from already-computed mappings (e.g. the ones
 * persisted on a worksheet), so a sheet already labelled doesn't need a
 * fresh Nabu detection to be displayed.
 */
export function from_question_mappings(sheet_name, mappings) {
  let $ = $dict.is_empty(mappings);
  if ($) {
    return new None();
  } else {
    let values = $dict.values(mappings);
    let _block;
    let _pipe = $list.first(values);
    let _pipe$1 = $result.map(
      _pipe,
      (mapping) => { return mapping.schema_version; },
    );
    _block = $result.unwrap(_pipe$1, 1);
    let schema_version = _block;
    let nodes = $list.map(
      values,
      (mapping) => {
        return new CellNode(mapping.anchor, mapping.cell_type, mapping.edges);
      },
    );
    return new Some(new SheetCellGraph(schema_version, sheet_name, nodes));
  }
}

/**
 * Turns freshly detected nodes into a mapping dict, ready to be persisted
 * or merged into an existing mapping. `normalize` lets callers collapse
 * detector-specific cell type variants (e.g. "sub_question" -> "question")
 * before storing.
 */
export function nodes_to_mapping_dict(
  schema_version,
  sheet_name,
  nodes,
  normalize
) {
  return $list.fold(
    nodes,
    $dict.new$(),
    (acc, node) => {
      return $dict.insert(
        acc,
        node.coordinates,
        new $cell_mapping.QuestionCellMapping(
          schema_version,
          sheet_name,
          node.coordinates,
          node.outgoing,
          normalize(node.cell_type),
        ),
      );
    },
  );
}
